<google-chart
[title]="title"
[type]="type"
[data]="data"
[columns]="columnName"
[width]="width"
[height]="height"
[options]="options"
></google-chart>
